import { UPDATE_FIND_AND_REPLACE_STATE } from '../../../../constants/ActionNameConstants';

const initialValues = {
  word: null,
  selectedIndex: null,
  wordSearchedId: null,
  mode: 'string',
  replaceText: null,
  isFillerWords: false,
  isMatchFullWord: false,
  isCaseSensitive: false,
  isCommonErrors: false,
};

const findAndReplaceReducer = (state = initialValues, action) => {
  switch (action.type) {
    case UPDATE_FIND_AND_REPLACE_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default findAndReplaceReducer;
